import {connect, IConnectProps} from 'globx-react';
import * as React               from 'react';
import {Subject}                from 'rxjs';

import StoreName              from '../../../../State/Shared/Constants/StoreName';
import IPlayerStores from '../../../../State/Shared/Interfaces/IPlayerStores';
import Captions               from '../../../../State/Stores/Captions/Captions';
import * as TestIds           from '../../../Shared/Constants/TestIds';
import UiEventType            from '../../../Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../../Shared/Interfaces/IUiEventsStreamPayload';
import composeTokenList       from '../../Util/composeTokenList';
import renderTestId           from '../../Util/renderTestId';

import IconCaptionsActive    from './Assets/IconCaptionsActive';
import IconCaptionsInactive  from './Assets/IconCaptionsInactive';
import * as styles           from './captionsMenuButton.css';

interface ICaptionButtonProps extends IConnectProps<Captions, IPlayerStores> {
    areControlsIdle: boolean;
    uiEvents$: Subject<IUiEventsStreamPayload>;
}

@connect(StoreName.CAPTIONS)
class CaptionsMenuButton extends React.Component<ICaptionButtonProps> {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    public shouldComponentUpdate(nextProps: ICaptionButtonProps): boolean {
        return nextProps.value.tracks !== this.props.value.tracks;
    }

    public render(): JSX.Element {
        const {areControlsIdle, value, stores} = this.props;
        const {config} = stores;
        const {tracks} = value;

        const captionsConfig = config.value.captions;

        if (tracks.length === 0 || !captionsConfig.enable) return null;

        const Icon = value.areCaptionsActive ? IconCaptionsActive : IconCaptionsInactive;

        const testIdBase = value.areCaptionsActive ?
            TestIds.PLAYER_CAPTIONS_MENU_BUTTON_ACTIVE :
            TestIds.PLAYER_CAPTIONS_MENU_BUTTON_INACTIVE;

        const testId = composeTokenList([
            testIdBase,
            [!areControlsIdle, testIdBase + '_VISIBLE']
        ]);

        return (
            <button
                className={styles.captionsMenuButton}
                onClick={this.handleClick}
                data-test-id={renderTestId(testId)}
            >
                <Icon />
            </button>
        );
    }

    private handleClick(): void {
        this.props.uiEvents$.next({
            type: UiEventType.CAPTIONS_MENU_BUTTON_TAP
        });
    }
}

export default CaptionsMenuButton;